import * as React from 'react';

export type SidebarLoaderContextProps = { functionToLoad: () => void };

export type SidebarLoaderContextType = {
    props: SidebarLoaderContextProps,
    setProps: (props: SidebarLoaderContextProps) => void
}

export const SidebarLoaderContext = React.createContext(null);

export const SidebarLoaderProvider: React.FC = ({ children }) => {
    const [props, setProps] = React.useState<SidebarLoaderContextProps>({ functionToLoad: null });
    return (
        <SidebarLoaderContext.Provider value={{ props, setProps }}>
            {children}
        </SidebarLoaderContext.Provider>
    );
};

